module.exports = "/templates/templates.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/templates.html
// module id = 481
// module chunks = 0